import { CHART_TOTAL_TIME_OPTIONS } from '~services/constant/statistics';
import HelperOptions from '~component/helper/helper-options';

// 统计图表时间范围下来列表
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;
    return (
      <div>
        <HelperOptions
          { ...data }
          options={ CHART_TOTAL_TIME_OPTIONS }
        />

      </div>
    );
  },
};
